import React, { memo } from 'react'

import { Icon, Upload2, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useThreeDModelEntryPoint from 'Pods/ThreeDStudio/Hooks/useThreeDModelEntryPoint'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function UseModelCard() {
  const t = useTranslation()
  const { isLoading, onClick } = useThreeDModelEntryPoint()

  return (
    <button
      type="button"
      className={classnames('model-card', 'model-card--action', 'model-card--use')}
      onClick={!isLoading ? onClick : undefined}
      aria-label={t('shared.uploadModel.upload')}
    >
      <span className="model-card__action">
        <Icon svgComponent={Upload2} size={iconSizeMedium} color="dark" notSpaced />
        <span className="model-card__action-text">
          {t('sidebar.useModelCard.titleLine1')}
          <br/>
          {t('sidebar.useModelCard.titleLine2')}
        </span>
      </span>
    </button>
  )
}

export default memo(UseModelCard)
